import React, { useState, useEffect } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import firebaseApp from "../../firebase/credenciales";
import { 
  getAuth, 
  signInWithEmailAndPassword, 
  deleteUser, 
  createUserWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { initializeApp, getApps } from "firebase/app";
import { firebaseWebConfig } from "../../config/firebaseEnv";
import * as XLSX from "xlsx";
import {
  Container,
  Card,
  Form,
  Button,
  Table,
  Spinner,
  Row,
  Col,
  Badge,
  Alert,
  ProgressBar
} from "react-bootstrap";
import {
  FaDownload,
  FaCheckCircle,
  FaExclamationTriangle,
  FaSyncAlt,
  FaSearch,
  FaShieldAlt,
  FaFileDownload,
  FaEnvelope,
  FaBell,
  FaPaperPlane
} from "react-icons/fa";
import { getFirestore, doc, updateDoc, getDoc } from "firebase/firestore";

// Funciones del sistema para notificaciones
import sendCustomEmail from "../../functions/sendCustomEmail";
import sendNotification from "../../functions/sendNotification";
import Swal from "sweetalert2";

const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

// Configuración para la instancia secundaria (Reset Auth)
const firebaseConfig = firebaseWebConfig;

const getSecondaryAuth = () => {
  const appName = "secondaryAppReset";
  let secondaryApp;
  const apps = getApps();
  const existingApp = apps.find(app => app.name === appName);
  if (existingApp) {
    secondaryApp = existingApp;
  } else {
    secondaryApp = initializeApp(firebaseConfig, appName);
  }
  return getAuth(secondaryApp);
};

const secondaryAuth = getSecondaryAuth();

function ChangePass({ usuario }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [statusMessage, setStatusMessage] = useState("");
  const [tempData, setTempData] = useState([]);
  const [preprocessedData, setPreprocessedData] = useState([]);
  const [isPreprocessed, setIsPreprocessed] = useState(false);
  const [notifying, setNotifying] = useState(false);
  const [channels, setChannels] = useState({ email: true, app: true });
  const [companyInfo, setCompanyInfo] = useState({
    name: "Mi Boleta",
    coleccionEmail: "mailTurbo"
  });

  // Obtener datos de la empresa para el remitente y colección de correo
  useEffect(() => {
    async function fetchCompany() {
      if (usuario?.ruc) {
        try {
          const docRef = doc(db, "company", usuario.ruc);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setCompanyInfo({
              name: data.name || "Mi Boleta",
              coleccionEmail: data.coleccionEmail || "mailTurbo"
            });
          }
        } catch (error) {
          console.error("Error fetching company info:", error);
        }
      }
    }
    fetchCompany();
  }, [usuario, db]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setResults([]);
    setTempData([]);
    setPreprocessedData([]);
    setIsPreprocessed(false);
    
    if (file) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        setTempData(data);
      };
      reader.readAsBinaryString(file);
    }
  };

  const downloadTemplate = () => {
    const template = [ { dni: "12345678" } ];
    const ws = XLSX.utils.json_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Plantilla");
    XLSX.writeFile(wb, "Plantilla_Reset_Seguridad.xlsx");
  };

  const downloadReport = () => {
    if (results.length === 0) return;
    const reportData = results.map(res => ({
        DNI: res.dni,
        Nombre: res.nombre,
        Email: res.email,
        "Nueva Contraseña": res.newPassword || "N/A",
        Estado: res.status === "success" ? "EXITOSO" : "ERROR",
        Mensaje: res.message
    }));
    const ws = XLSX.utils.json_to_sheet(reportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reporte_Reset");
    XLSX.writeFile(wb, `Reporte_Reset_Seguridad_${new Date().getTime()}.xlsx`);
  };

  const handlePreprocess = async () => {
    if (tempData.length === 0) return;
    setLoading(true);
    setProgress(0);
    setStatusMessage("Analizando usuarios...");
    
    const analyzed = [];
    for (let i = 0; i < tempData.length; i++) {
        const dni = tempData[i].dni?.toString();
        if (!dni) continue;

        try {
            const userRef = doc(db, "users", dni);
            const userSnap = await getDoc(userRef);
            
            if (userSnap.exists()) {
                const userData = userSnap.data();
                analyzed.push({
                    dni,
                    email: userData.email || "Sin correo",
                    nombre: `${userData.name || ''} ${userData.apellidos || ''}`.trim() || "Sin nombre",
                    exists: true,
                    status: "ready"
                });
            } else {
                analyzed.push({ dni, email: "N/A", nombre: "No encontrado", exists: false, status: "error" });
            }
        } catch (error) {
            analyzed.push({ dni, email: "Error", nombre: error.message, exists: false, status: "error" });
        }
        setProgress(Math.round(((i + 1) / tempData.length) * 100));
    }
    
    setPreprocessedData(analyzed);
    setIsPreprocessed(true);
    setLoading(false);
    setStatusMessage("Análisis completado.");
  };

  const executeReset = async () => {
    if (preprocessedData.length === 0) return;
    setLoading(true);
    setProgress(0);
    const newResults = [];
    const targets = preprocessedData.filter(u => u.exists);
    
    for (let i = 0; i < targets.length; i++) {
      const u = targets[i];
      let status = "success";
      let message = "Reset exitoso";
      let newPassword = "-";

      try {
        setStatusMessage(`Reseteando ${u.email}...`);
        try {
          await signInWithEmailAndPassword(secondaryAuth, u.email, u.dni);
          if (secondaryAuth.currentUser) await deleteUser(secondaryAuth.currentUser);
        } catch {}

        newPassword = Math.random().toString(36).slice(-10) + "!" + Math.floor(Math.random() * 100);
        await createUserWithEmailAndPassword(secondaryAuth, u.email, newPassword);
        
        await updateDoc(doc(db, "users", u.dni), {
          mustChangePassword: true,
          lastReset: new Date().toISOString(),
          resetBy: usuario.email
        });
        await signOut(secondaryAuth);
      } catch (error) {
        status = "error";
        message = error.code === "auth/email-already-in-use" ? "Email ya en uso" : error.message;
        newPassword = "ERROR";
      }

      newResults.push({ ...u, status, message, newPassword });
      setResults([...newResults]);
      setProgress(Math.round(((i + 1) / targets.length) * 100));
    }
    setLoading(false);
    setStatusMessage("Proceso finalizado.");
  };

  const sendSecurityNotifications = async () => {
    // Intentamos obtener de results (si se acaba de resetear) 
    // o de preprocessedData (si solo se cargó el excel para notificar)
    let targets = [];
    
    if (results.length > 0) {
        // Si hubo un proceso de reset, intentamos notificar a los exitosos
        targets = results.filter(r => r.status === "success");
        // SI no hay exitosos (porque ya estaban reseteados), usamos los de la lista original que sí existen
        if (targets.length === 0) {
            targets = preprocessedData.filter(u => u.exists);
        }
    } else {
        // Si es modo "Solo Notificar" directo
        targets = preprocessedData.filter(u => u.exists);
    }
    
    if (targets.length === 0) {
        Swal.fire("Atención", "No hay usuarios válidos seleccionados para notificar.", "warning");
        return;
    }

    const confirm = await Swal.fire({
        title: '¿Enviar notificaciones?',
        text: `Se enviará un correo y un aviso push a ${targets.length} colaboradores.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar ahora',
        cancelButtonText: 'Cancelar'
    });

    if (!confirm.isConfirmed) return;

    setNotifying(true);
    setProgress(0);
    setStatusMessage("Iniciando envío masivo...");

    const subject = `⚠️ Acción Requerida: Actualización de Seguridad ${companyInfo.name}`;
    const bodyText = `Estimado colaborador, por motivos de seguridad tu cuenta ha sido protegida. Para ingresar nuevamente, por favor abre tu aplicación y utiliza la opción "Olvidé mi contraseña" para crear una nueva clave personal.`;
    
    const bodyHtml = `
      <div style="font-family: Arial, sans-serif; padding: 20px; border: 1px solid #eee; border-radius: 8px;">
        <h2 style="color: #d32f2f;">Aviso de Seguridad Mi Boleta</h2>
        <p>Estimado(a) <strong>colaborador(a)</strong>,</p>
        <p>Tu cuenta ha sido protegida recientemente por motivos de seguridad.</p>
        <p><strong>Pasos para recuperar tu acceso:</strong></p>
        <ol>
          <li>Entra a la App <strong>Mi Boleta</strong>.</li>
          <li>Haz clic en <strong>"Olvidé mi contraseña"</strong>.</li>
          <li>Crea una nueva clave privada.</li>
        </ol>
        <p style="color: #666; font-size: 0.9em; margin-top: 20px;">Equipo de Recursos Humanos - ${companyInfo.name}</p>
      </div>`;

    for (let i = 0; i < targets.length; i++) {
        const u = targets[i];
        setStatusMessage(`Notificando a ${u.email}...`);
        try {
            // 1. Enviar Email (Solo si está habilitado)
            if (channels.email) {
                const emailRes = await sendCustomEmail(u.email, "", "", subject, bodyText, companyInfo.coleccionEmail);
                console.log(`✉️ [Email] Destinatario: ${u.email} | ID Doc: ${emailRes.id}`);
            }
            
            // 2. Enviar Notificación Interna (Solo si está habilitado)
            if (channels.app) {
                const notifRes = await sendNotification(
                    u.dni,
                    "comunication-agent",
                    { text: "⚠️ Acción de Seguridad Requerida: Por motivos de protección, tu cuenta ha sido reseteada. Por favor, utiliza la opción 'Olvidé mi contraseña' en la pantalla de inicio de esta App para crear una nueva clave personal." }
                );
                console.log(`[Seguridad] Notificación interna → ai_chats/${u.dni}/comunication-agent | success: ${notifRes?.success} | id: ${notifRes?.id}`);
            }
        } catch (error) {
            console.error(`❌ Error notificando a ${u.dni}:`, error);
        }
        setProgress(Math.round(((i + 1) / targets.length) * 100));
    }

    setNotifying(false);
    setStatusMessage("Notificaciones enviadas.");
    Swal.fire("¡Proceso Finalizado!", `Se enviaron avisos a ${targets.length} trabajadores.`, "success");
  };

  return (
    <Container className="mt-4 pb-5">
      <Card className="shadow-sm border-0">
        <Card.Header className="text-white py-4 position-relative" style={{ background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)", borderBottom: "3px solid #f59e0b" }}>
          <div className="position-absolute end-0 top-50 translate-middle-y me-4" style={{ zIndex: 10 }}>
            <BotonManualHeader />
          </div>
          <div className="text-center">
            <h2 className="fw-bold mb-1">
              <FaShieldAlt className="me-3" />
              Reset & Notificación Masiva
            </h2>
            <p className="mb-0 opacity-75">
              Administración de credenciales de seguridad de los usuarios - {companyInfo.name}
            </p>
          </div>
        </Card.Header>
        <Card.Body>
          <Alert variant="warning" className="small py-2 border-0 shadow-sm mb-4 text-dark">
            <FaExclamationTriangle className="me-2" />
            <strong>Modo Dual:</strong> Puedes resetear cuentas o <strong>simplemente notificar</strong> a usuarios ya reseteados subiendo sus DNIs.
          </Alert>

          <Row className="mb-4">
            <Col md={4}><Button variant="outline-primary" size="sm" onClick={downloadTemplate} className="w-100 mb-2"><FaDownload className="me-1" /> Bajer Plantilla</Button></Col>
            <Col md={8}><Form.Control type="file" onChange={handleFileChange} accept=".xlsx, .xls" size="sm" /></Col>
          </Row>

          {tempData.length > 0 && !isPreprocessed && !loading && (
            <div className="text-center p-3 border rounded bg-light mb-4">
              <Button variant="primary" onClick={handlePreprocess}><FaSearch className="me-2" /> Analizar Lista de Usuarios</Button>
            </div>
          )}

          {(loading || notifying) && (
            <div className="text-center my-4 p-3 border rounded shadow-sm bg-light">
              <ProgressBar animated now={progress} label={`${progress}%`} className="mb-2" variant={notifying ? "success" : "danger"} />
              <p className={notifying ? "text-success fw-bold small" : "text-danger fw-bold small"}>{statusMessage}</p>
            </div>
          )}

          {isPreprocessed && !loading && !notifying && (
            <div className="mt-3">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3 gap-2">
                <div className="d-flex align-items-center gap-3">
                    <Form.Check type="checkbox" label="Email" checked={channels.email} onChange={(e) => setChannels({...channels, email: e.target.checked})} className="small" />
                    <Form.Check type="checkbox" label="App" checked={channels.app} onChange={(e) => setChannels({...channels, app: e.target.checked})} className="small" />
                    <Button variant="info" size="sm" onClick={sendSecurityNotifications} className="text-white px-3 shadow-sm">
                        <FaPaperPlane className="me-2" /> Solo Notificar
                    </Button>
                    <Button variant="danger" size="sm" onClick={executeReset} className="px-3 shadow-sm">
                        <FaSyncAlt className="me-2" /> Ejecutar Reset
                    </Button>
                </div>
              </div>
              
              <div style={{ maxHeight: "250px", overflowY: "auto" }} className="border rounded shadow-sm">
                <Table size="sm" striped hover className="mb-0 text-center x-small">
                  <thead className="bg-light sticky-top">
                    <tr><th>DNI</th><th>Nombre</th><th>Email</th><th>Base Datos</th></tr>
                  </thead>
                  <tbody>
                    {preprocessedData.map((u, idx) => (
                      <tr key={idx}>
                        <td>{u.dni}</td>
                        <td className="text-start small">{u.nombre}</td>
                        <td className="small">{u.email}</td>
                        <td><Badge bg={u.exists ? "success" : "danger"}>{u.exists ? "ENCONTRADO" : "FALTANTE"}</Badge></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          )}

          {results.length > 0 && !loading && !notifying && (
            <div className="mt-4 pt-3 border-top">
              <div className="d-flex justify-content-between align-items-center mb-3 bg-success bg-opacity-10 p-2 rounded">
                <h6 className="text-success mb-0 fw-bold"><FaCheckCircle className="me-2" />Reset Finalizado con {results.length} resultados</h6>
                <Button variant="success" size="sm" onClick={downloadReport}><FaFileDownload className="me-2" /> Reporte de Claves</Button>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ChangePass;
